/*!
 *
 * Copyright 2019 Dmitry Chuba
 */

// import PDFObject from 'pdfobject';
import bsCustomFileInput from './bsCustomFileInput';


jQuery(function ($) {
    'use strict';
    bsCustomFileInput.init();

/*
    // bs Validations
    {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        const forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                let reqWith          = true;
                const elRequiredWith = $(form).find('[data-required-with]')

                elRequiredWith.each(function () {
                    const withElementName = $(this).data('required-with');
                    if ($(form).find(`[name="${withElementName}"]`).val().length > 0 && $(this).val().length == 0) {
                        $(this)[0].setCustomValidity("Invalid field.")
                        reqWith = false;
                    } else {
                        $(this)[0].setCustomValidity("")
                    }
                })

                if (form.checkValidity() === false || reqWith === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                form.classList.add('was-validated');

            }, false);
        });
    }
*/

});
